const screenfull = require('screenfull');

module.exports = class Menu {
    isFullscreenSupported() {
        const root = document.documentElement;
        return root.requestFullscreen
        || root.webkitRequestFullscreen
        || root.mozRequestFullScreen
        || root.msRequestFullscreen;
    }

    getFullscreen() {
        if (!this.isFullscreenSupported()) return;

        let minIcon;
        let maxIcon;
        if (this.theme === 'black') {
            maxIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/FullScreenWithBG.svg';
            minIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/MinimiseWithBG.svg';
        } else {
            maxIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/Full_Screen.svg';
            minIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/Minimise.svg';
        }
        const img = $('<img style=\'width:100%; cursor: pointer;\'>');
        img.attr('src', screenfull.isFullscreen ? minIcon : maxIcon);
        screenfull.on('change', () => {
            img.attr('src', screenfull.isFullscreen ? minIcon : maxIcon);
        });
        img.on('click', () => {
            screenfull.toggle(document.documentElement);
        });

        // eslint-disable-next-line consistent-return
        return img;
    }

    getCaptionsButton() {
        let ccOnIcon;
        let ccOffIcon;

        /* eslint-disable max-len */
        if (this.theme === 'black') {
            ccOnIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/v1730893238/core-interactives/shared/cc-icon-on.svg';
            ccOffIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/v1730893238/core-interactives/shared/cc-icon-off.svg';
        } else {
            ccOnIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/v1730893238/core-interactives/shared/cc-icon-on-white.svg';
            ccOffIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/v1730893238/core-interactives/shared/cc-icon-off-white.svg';
        }

        const element = $('<img style="width:100%;cursor: pointer;">');

        const captionsAreOn = $('#caption').length > 0 || $('#caption').is(':visible');
        element.attr('src', captionsAreOn ? ccOnIcon : ccOffIcon);

        element.on('click', () => {
            const $captionsDiv = $('#caption');
            const isVisible = $captionsDiv.is(':visible');
            if (isVisible) {
                $captionsDiv.hide();
            } else {
                $captionsDiv.show();
            }
            element.attr('src', !isVisible ? ccOnIcon : ccOffIcon);
        });

        return element;
    }


    updateSound(element, isMuted) {
        let muteIcon;
        let unmuteIcon;
        if (this.theme === 'black') {
            muteIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/VolumeOffWithBG.svg';
            unmuteIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/VolumeWithBG.svg';
        } else {
            muteIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/Volume_Off.svg';
            // eslint-disable-next-line max-len
            unmuteIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/v1523008957/core-interactives/shared/Volume.svg';
        }
        if (isMuted) {
            element.attr('src', muteIcon);
        } else {
            element.attr('src', unmuteIcon);
        }
        $('audio').prop('muted', isMuted);
        $('video').prop('muted', isMuted);
        this.muted = isMuted;
    }

    isMuted() {
        return this.muted;
    }

    getSoundButton() {
        this.muted = false;
        const element = $('<img style=\'width:100%;cursor: pointer;\'>');

        element.on('click', () => {
            this.updateSound(element, !this.muted);
        });
        this.updateSound(element, false);
        return element;
    }

    getHelpButton(helpPopup) {
        let icon;
        if (this.theme === 'black') {
            icon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/InfoWithBG.svg';
        } else {
            icon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/Info.svg';
        }
        const element = $('<img style=\'width:100%;cursor: pointer;\'>');
        element.attr('src', icon).attr('id', 'helpButton');
        element.on('click', () => {
            helpPopup.show();
        });
        helpPopup.find('.close').on('click', () => {
            helpPopup.hide();
        });
        return element;
    }

    constructor(parent, option) {
        this.option = option;
        this.theme = option.theme;
        const menu = $('<div/>').css({
            width: '3.6em',
            position: 'absolute',
            top: '.8em',
            'z-index': 10050,
            right: '.8em',
            padding: '.7em',
            'border-radius': '5em',
        });
        menu.addClass('common_menu');
        let elementCount = 0;
        if (option.fullScreen === true) {
            const fullscreen = this.getFullscreen();
            menu.append(fullscreen);
            elementCount += 1;
        }
        if (option.sound === true) {
            const sound = this.getSoundButton();
            if (elementCount > 0) { sound.css({ 'padding-top': '.55em' }); }
            menu.append(sound);
            elementCount += 1;
        }

        if (option.captions === true) {
            const captions = this.getCaptionsButton();
            if (elementCount > 0) { captions.css({ 'padding-top': '.55em' }); }
            menu.append(captions);
            elementCount += 1;
        }

        if (option.helpElement != null) {
            const help = this.getHelpButton(option.helpElement);
            if (elementCount > 0) { help.css({ 'padding-top': '.55em' }); }
            menu.append(help);
            elementCount += 1;
        }
        if (elementCount > 1) {
            if (this.theme === 'black') {
                menu.css({ background: 'rgba(0, 0, 0, 0.25)' });
            } else {
                menu.css({ background: 'rgba(255, 255, 255, 0.25)', 'border-radius': '0em 0em 5em 5em' });
            }
        }
        parent.append(menu);
    }
};
